module.exports = __webpack_public_path__ + "static/media/sign-form.1689a746.png";